import IAlertBox from "./controls/IAlertbox";
import IAPIError from "./controls/iAPIError";
import IContainer from "./controls/IContainer";
import ILoadingBar from "./controls/iLoadingBar";
import IPopover from "./controls/IPopover";
import ISelectBox from "./controls/ISelectbox";
import IMultiSelect from "./controls/IMultiSelect";
import ITextBox from "./controls/iTextbox";
import IToggle from "./controls/IToogle";
import IAutoComplete from "./controls/IAutoComplete";
import { useFormContext } from "./form/IForm";
import useCookie from "./hooks/useCookie";
import { useINavigation } from "./hooks/useINavigation";

export const ICore = {
  ITextBox,
  ILoadingBar,
  IAPIError,
  IAlertBox,
  IContainer,
  IPopover,
  ISelectBox,
  IMultiSelect,
  IAutoComplete,
  IToggle,
  useFormContext,
  useCookie,
  useINavigation,
};
